import { isTerminalStatus, type JobStatus } from '@detachly/contracts'

export const FAST_POLL_MS = 2_000
export const SLOW_POLL_MS = 5_000
/** A job that has been running this long is not about to finish in the next two seconds. */
export const BACKOFF_AFTER_MS = 120_000

/**
 * How long to wait before asking about a job again — `null` once it stopped moving.
 * Terminal jobs are never polled: the runner cannot change them any more.
 */
export function pollIntervalMs(status: JobStatus, watchedForMs: number): number | null {
  if (isTerminalStatus(status)) return null
  return watchedForMs >= BACKOFF_AFTER_MS ? SLOW_POLL_MS : FAST_POLL_MS
}
